<template>
	<section>
		<header-page 
			name="Configuration"
			:title="$route.meta.title"/>
		<router-view></router-view>
		<action-bar
			:actions="actions"
			@open-modal="openModal"
		></action-bar>
 </section>
</template>

<script>
import actionBar from '@/components/shared/action-bar';

function openModal() {
	if (this.$route.name === 'page-config-dealers') {
		this.goTo('page-dealers-new');
	} else {
		this.goTo('page-implementers-create');
	}
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CU',
				text: 'Crear Usuario',
				img: 'https://goo.su/WxxSy',
				active: true,
			},
		],
	};
}

export default {
	components: {
		actionBar,
	},
	data,
	name: 'page-configuration',
	methods: {
		openModal,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/configuration/page-configuration.vue